import React, { forwardRef } from 'react';
import { TextInput } from 'react-native';
import { Input } from '@ui-kitten/components';
export const DNAInput = forwardRef((props, ref) => {
    const { size, status, ...rest } = props;
    return (<Input ref={ref} size={size ?? 'md'} status={status ?? 'basic'} {...rest}/>);
});
export default {
    Native: TextInput,
    Kitten: DNAInput,
};
//# sourceMappingURL=TextField.js.map